/** Parámetros de red y simulación compartidos entre cliente y servidor. */
export const NET = {
  /** Frecuencia de simulación autoritativa (Hz). El cliente predice con el mismo paso fijo. */
  TICK_RATE: 30,
  /** Se envía un snapshot cada N ticks (30/2 = 15 Hz por defecto). */
  SNAPSHOT_DIVISOR: 2,
  /** Retardo de interpolación para jugadores remotos (ms). */
  INTERPOLATION_DELAY_MS: 160,
  /** Máximo de inputs que el servidor acepta por segundo y jugador (paso fijo + margen). */
  MAX_INPUTS_PER_SECOND: 34,
  /** Ráfaga máxima de inputs acumulables (absorbe jitter de red sin permitir speed-hacks). */
  INPUT_BURST: 8,
  /** Si no llegan inputs durante este tiempo, el servidor simula con input vacío (gravedad). */
  INPUT_STARVATION_MS: 250,
} as const;

export const FIXED_DT = 1 / NET.TICK_RATE;

export const ROOM_LIMITS = {
  MIN_PLAYERS_TO_START: 1,
  DEFAULT_MAX_PLAYERS: 10,
  ABSOLUTE_MAX_PLAYERS: 12,
  MIN_CONFIGURABLE_PLAYERS: 2,
  CODE_LENGTH: 5,
  /** Alfabeto sin caracteres ambiguos (0/O, 1/I). */
  CODE_ALPHABET: 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789',
} as const;

export const CHAT_LIMITS = {
  MAX_LENGTH: 160,
  /** Mensajes permitidos por ventana. */
  BURST: 5,
  WINDOW_MS: 10_000,
} as const;

export const NAME_LIMITS = { MIN: 3, MAX: 16 } as const;

export const FACE_TEXTURE = {
  SIZE: 256,
  MAX_BYTES: 180 * 1024,
  MIME_TYPES: ['image/webp', 'image/jpeg', 'image/png'] as const,
} as const;

export const PHOTO_INPUT = {
  MAX_BYTES: 12 * 1024 * 1024,
  MAX_DIMENSION: 8000,
  MIN_DIMENSION: 128,
} as const;

export const PHASE_DURATIONS = {
  COUNTDOWN_MS: 4_000,
  RESULTS_MS: 18_000,
} as const;
